export class VesselType {
    Id: number;
    NameEN: string;
    NameAR: string;
};


export class CircularsVesselType {
    Id: number;
    NameEN: string;
    NameAR: string;
    VesselTypeId:number;
    CircularsLookupID:number; 
};

